// extracted by mini-css-extract-plugin
export default {"submit":"CreateEndOfCareSummaryPage_submit__+uxAI"};